function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Header = /*#__PURE__*/function () {
  function Header() {
    _classCallCheck(this, Header);
  }

  _createClass(Header, null, [{
    key: "fixedHeaderListener",
    value: function fixedHeaderListener(el) {
      var fixed = window.scrollY > el.clientHeight;

      if (fixed) {
        el.classList.add('is-fixed');
      } else {
        el.classList.remove('is-fixed');
      }
    }
  }, {
    key: "ellipsizeTextBox",
    value: function ellipsizeTextBox(el) {
      var text = el.getAttribute('title');

      if (!text) {
        el.setAttribute('title', el.innerText);
      } else {
        el.innerText = text;
      }

      var i = 0;

      while (el.clientHeight !== el.scrollHeight && el.clientHeight + 1 !== el.scrollHeight && i < 1) {
        el.innerText = el.innerText.replace(/\W*\s(\S)*$/, '...'); // add an ellipsis at the last shown space

        i++;
      }
    }
  }, {
    key: "register",
    value: function register() {
      var $header = document.querySelector('.header > .fixer');

      if (!$header) {
        return;
      }

      var $title = $header.querySelector('.form-title span');

      if (!$title) {
        return;
      }

      Header.fixedHeaderListener($header);
      window.addEventListener('scroll', function () {
        Header.fixedHeaderListener($header);
      });

      if ($title) {
        Header.ellipsizeTextBox($title);
        window.addEventListener('resize', function () {
          Header.ellipsizeTextBox($title);
        });
      }
    }
  }]);

  return Header;
}();

export default Header;